import React from "react";
import {withRouter , Route, Switch} from "react-router-dom";
import './App.scss';
import Grid from '@material-ui/core/Grid';
import setting from './assets/images/ic_setting.png'
import goldCup from './assets/images/ic_leader_icon.png'
import shopIcon from './assets/images/ic_storee.png'
import walletIcon from './assets/images/ic_wallet_icon.png'
import homeIcon from './assets/images/ic_home_icon.png'
import HomeIndex from './components/pages/Home/HomeIndex'
import SplashScreen from './components/pages/SplashScreen'
import LeagueStart from './components/pages/Home/LeagueStart'
import Question from './components/pages/Home/Question'
import GiftHall from './components/pages/Home/GiftHall'
import SettingIndex from './components/pages/Settings/SettingIndex'
import WinnersTable from './components/pages/WinnerTable/WinnersTableIndex'
import MainLeague from './components/pages/WinnerTable/MainLeague'
import Wallet from './components/pages/Wallet/WalletIndex'
import MarketIndex from "./components/pages/Market/MarketIndex";
import LuckSpinner from "./components/pages/Home/LuckSpinner";
import SettingsFreePage from "./components/pages/Settings/FreePage";
import QuestionResult from "./components/pages/Home/QuestionResult";
import TotalPrizes from "./components/pages/Home/TotalPrizes";
import Login from "./components/pages/Login";
import Dialogue from "./components/pages/Settings/Dialogue";
import { withStyles } from '@material-ui/styles';
import {connect} from "react-redux";
import {dialog} from "./Store/Actions/DialogAction";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "./components/pageComponents/Common/Dialog";
import Dialog from "@material-ui/core/Dialog";
import {dialogBackground, dialogBorderColor, dialogContentColor, dialogContentTextColor} from "./Utility/Theme";


class FullWidthGrid extends React.Component {
    constructor(props) {
        super(props)
        this.navs=React.createRef()
        this.props.history.listen((location, action) => {
            const {url}=this.state
            if (url!==location.pathname){

                this.setState({
                    url:location.pathname
                })
                // alert('changed to '+ location.pathname)
            }
            // console.log(this.state)
            // console.log(window.location.pathname)
            // console.log(location.pathname)
            // this.activeNavElement(location.pathname)
        });
        this.state={
            dialogData:null,
            showNavbar:true,
            activeNav:false,
            url:null,
            style: {
                completed:5,
                root: {
                    // backgroundImage: "url(" + backgroundImage + ")",
                    maxWidth:'500px' ,
                    margin:'auto',
                    flex:1,
                    display:'flex',
                    flexDirection:'column',
                    minHeight:'0',
                },
                mainRow: {
                    margin: 'auto',
                    width: '95%',
                    padding: 'auto',
                    backgroundColor:'blue'
                },

                navigationImage:{
                    width: '40px',
                },
                navigationText:{
                    color:'white',
                }
            }
        }
    }
    toggleBottomNavbar=(state)=>{
        this.setState({
            showNavbar:state
        })
    }
    removeActiveNav=(id)=>{
        const {url,showNavbar}=this.state
        if (id===url || !showNavbar)
            return
        let nav= document.getElementById('navBar').getElementsByTagName('div');
        for(let i=0; i< nav.length; i++ ) {
            if(nav[i].classList.contains('active')){
                nav[i].classList.remove("active");
                nav[i].classList.remove("MuiGrid-grid-sm-4");
                nav[i].classList.remove("MuiGrid-grid-xs-4");
            }
        }
        this.setState({
            url:`${id?id:'/home'}`
        })
        this.props.history.push(`${id}`);
    }
    componentDidMount() {
        this.removeActiveNav(window.location.pathname)
    }
    render(){
        const showNavbar = this.state.showNavbar;
        const navBarItems=[
            {
                id:'settings',
                text:'تنظیمات',
                icon:setting,
                cols:2,
                url:'/settings'
            },
            {
                id: 'winners-table',
                text:'جدول برندگان',
                icon:goldCup,
                cols:2,
                url:'/winners-table'
            },
            {
                id:'home',
                text:'خانه',
                icon:homeIcon,
                cols:2,
                url:'/home'
            },
            {
                id: 'shop',
                text:'فروشگاه',
                icon:shopIcon,
                cols:2,
                url:'/shop'
            },
            {
                id:'wallet',
                text:'کیف پول',
                icon:walletIcon,
                cols:2,
                url:'/wallet'
            },
        ]
        const obg ={
            dialog:{
                success:false,
                ok:null,
                message:this.state.resDialogText,
                style: {
                    background: dialogBackground,
                    borderColor: dialogBorderColor,
                    contentColor: dialogContentColor,
                    contentTextColor: dialogContentTextColor,
                    type: "danger",
                },
                cancel:{
                    action: "#cancel",
                    text: 'باشه'
                }
            }
        }

        const dialogObject= {
            dialog:{
                id: 0,
                icon:'',
                title: "خطا",
                message: `تبریک تست دریافت کردید .`,
                ok: null,
                cancel: {
                    text: "باشه",
                    action: "#ok"
                },
                style: {
                    type: "danger",
                    borderColor: dialogBorderColor,
                    background: dialogBackground,
                    contentColor: dialogContentColor,
                    contentTextColor: dialogContentTextColor
                }
            }
        }
        const dialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:dialogObject.dialog,
            },
            visible:false
        }
       const dialogData  = this.props.Dialog.data

        const closeDialog=()=>{
            this.props.dialog(dialog)
        }
        return (
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                style={this.state.style.root}
            >
                { dialogData &&
                    <Dialog
                        // disableBackdropClick
                        open={dialogData.visible}
                        // onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        style={{background:'transparent !important'}}
                        PaperProps={{
                            style: {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <DialogContent>
                            <CustomDialog  action={closeDialog} data={dialogData}/>
                        </DialogContent>
                    </Dialog>
                }


                <Grid item container xs={12} sm={12}
                      style={{
                          position:'relative',
                          display:'flex',
                          flexDirection:'column',
                          minHeight:'0',
                          flex:1,

                      }}
                >
                    <Switch>
                        <Route exact path="/settings">
                            <SettingIndex toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/settings/:id?">
                            <Dialogue toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/free">
                            <SettingsFreePage toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/home">
                            <HomeIndex toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/">
                            <SplashScreen toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/login">
                            <Login toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/home/luck-spinner">
                            <LuckSpinner toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/home/gift-hall">
                            <GiftHall toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/home/total-prizes/:id?">
                            <TotalPrizes toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/home/question-result">
                            <QuestionResult toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/league-start">
                            <LeagueStart toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/league-start/question">
                            <Question toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/winners-table">
                            <WinnersTable toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/winners-table/:id?">
                            <MainLeague toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        {/*<Route path="/shop">*/}
                        {/*    <MarketIndex/>*/}
                        {/*</Route>*/}
                        {/*<Route path="/shop/:id?" component={MarketIndex} />*/}
                        {/*<Route path="/shop/:id?" render={(props) => <MarketIndex/>}/>*/}


                        <Route exact path="/shop/:id?">
                            <MarketIndex toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                        <Route exact path="/wallet">
                            <Wallet toggleBottomNavbar={this.toggleBottomNavbar}/>
                        </Route>
                    </Switch>
                    {showNavbar &&
                    <Grid
                        direction="row" justify="center" alignItems="center" item container
                        className={'bottomNavbar'}
                        id={'navBar'}
                        style={{
                            // backgroundColor:'#354254',
                            bottom:'0',
                            flex:'none'
                        }}
                    >
                        {
                            navBarItems.map(data=>{
                                return(
                                    <Grid direction='column' justify="center" alignContent='center' alignItems='center' container
                                          onClick={() => this.removeActiveNav(`/${data.id}`)}
                                        // onClick={() => redirect(data.url)}
                                        //   className={"singlePage " + (this.state.url===`/${data.id}` ? 'active MuiGrid-grid-sm-4 MuiGrid-grid-xs-4' : '')}
                                          className={"singlePage " + ((this.state.url)&&(this.state.url.startsWith(`/${data.id}`)) ? 'active MuiGrid-grid-sm-4 MuiGrid-grid-xs-4' : '')}
                                        // className={"singlePage"}
                                          key={data.id}
                                          item
                                          id={data.id}
                                          sm={data.cols}
                                          xs={data.cols}
                                    >
                                        <img src={data.icon}
                                             style={this.state.style.navigationImage}
                                             alt=""/>
                                        <h5 style={this.state.style.navigationText}>
                                            {data.text}
                                        </h5>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                    }
                </Grid>
            </Grid>
        );
    }
}
// export default FullWidthGrid
const mapStateToProps=state=>({
    Dialog:state.Dialog
})
export default connect(mapStateToProps,{dialog})(withRouter(FullWidthGrid))
